export default __webpack_public_path__ + "static/media/err-500.a45d4f45.svg";